"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralCommissionAllocatedV1 = void 0;
const zod_1 = require("zod");
const event_1 = require("./event");
exports.ReferralCommissionAllocatedV1 = (0, event_1.defineEvent)({
    type: 'settlement.referral-commission.allocated',
    version: 1,
    payload: zod_1.z.object({
        saleId: zod_1.z.string().min(1),
        referrerId: zod_1.z.string().min(1),
        referredId: zod_1.z.string().min(1),
        amount: event_1.MonetaryValueSchema,
        commission: zod_1.z.object({ id: zod_1.z.string().min(1), amount: event_1.MonetaryValueSchema, availableAt: zod_1.z.string().datetime({ offset: true }) }).strict(),
        reserve: zod_1.z.object({ id: zod_1.z.string().min(1), amount: event_1.MonetaryValueSchema, availableAt: zod_1.z.string().datetime({ offset: true }) }).strict(),
        allocatedAt: zod_1.z.string().datetime({ offset: true }),
    }).strict(),
});
//# sourceMappingURL=referrals.js.map